<template>
    <div v-if="sidebar" @click="sidebar = false" class="fixed top-0 left-0 w-full h-full z-50">

        <div v-if="sidebar" class=" bg-slate-600 top-0 left-0 w-full h-full  absolute opacity-70"></div>
        <div v-if="sidebar"
            class="h-screen max-w-xs overflow-scroll  px-2 max-w-xl bg-white shadow-xl fixed z-50 flex flex-col right-0 top-0">

            <!-- <blockquote class="instagram-media" data-instgrm-captioned
                data-instgrm-permalink="https://www.instagram.com/reel/C3spVfItw2r/?utm_source=ig_embed&amp;utm_campaign=loading"
                data-instgrm-version="14"
                style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);">
                <div style="padding:16px;"> <a
                        href="https://www.instagram.com/reel/C3spVfItw2r/?utm_source=ig_embed&amp;utm_campaign=loading"
                        style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;"
                        target="_blank">
                        <div style=" display: flex; flex-direction: row; align-items: center;">
                            <div
                                style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;">
                            </div>
                            <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;">
                                <div
                                    style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;">
                                </div>
                                <div
                                    style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;">
                                </div>
                            </div>
                        </div>
                        <div style="padding: 19% 0;"></div>
                        <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px"
                                height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg"
                                xmlns:xlink="https://www.w3.org/1999/xlink">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g transform="translate(-511.000000, -20.000000)" fill="#000000">
                                        <g>
                                            <path
                                                d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631">
                                            </path>
                                        </g>
                                    </g>
                                </g>
                            </svg></div>
                        <div style="padding-top: 8px;">
                            <div
                                style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">
                                Bu gönderiyi Instagram&#39;da gör</div>
                        </div>
                        <div style="padding: 12.5% 0;"></div>
                        <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;">
                            <div>
                                <div
                                    style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);">
                                </div>
                                <div
                                    style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;">
                                </div>
                                <div
                                    style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);">
                                </div>
                            </div>
                            <div style="margin-left: 8px;">
                                <div
                                    style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;">
                                </div>
                                <div
                                    style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)">
                                </div>
                            </div>
                            <div style="margin-left: auto;">
                                <div
                                    style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);">
                                </div>
                                <div
                                    style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);">
                                </div>
                                <div
                                    style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);">
                                </div>
                            </div>
                        </div>
                        <div
                            style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;">
                            <div
                                style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;">
                            </div>
                            <div
                                style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;">
                            </div>
                        </div>
                    </a>
                    <p
                        style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">
                        <a href="https://www.instagram.com/reel/C3spVfItw2r/?utm_source=ig_embed&amp;utm_campaign=loading"
                            style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;"
                            target="_blank">İnanç Turizm (@inanc_turizm)&#39;in paylaştığı bir gönderi</a></p>
                </div>
            </blockquote> -->
           
            <div class="row justify-content-center text-left text-xs text-slate-700 leading-5">

                <h2 class="text-slate-600 font-semibold text-center text-lg my-3 leading-7">Her şey sizin için
                    Düşünüldü </h2>
                <p class="text-xs">Burada, her şeyi planlayarak çalışan, küçük detaylara bile azami özen gösteren güçlü
                    bir
                    ekip, büyük bir aile var.
                    18 yılı aşkın süredir yüksek memnuniyet hedefini başarıyla yakalayan güçlü bir kadro, İnanç
                    Tur'un mutlu umre müşterileri arasına katılan on binlerce mutlu yolcumuz var. İş ve sanat
                    dünyasından tanınmış isimler, siyasetçiler, bilim insanları, sporcular, edebiyatçılar gibi
                    onlarca alanda tanınmış yüzlerce referans var. Burada aile olmayı başarabilmiş
                    profesyoneller, disiplinli çalışan kıymetli hocalar, işinin uzmanı turizmciler var. Her
                    şeyin sistemli bir şekilde çalışmasını sağlayan özel bir yazılım altyapısı, sistemli
                    çalışmayı başarıyla uygulayan disiplinli bir ekip var. Burada sizlerin duasını alarak her
                    sene daha da iyi yerlere gelen inanmış insanlar var.
                    Çünkü burada her şeyin iyisini hak eden siz değerli misafirlerimiz var.</p>
            </div>
            <div class="row">
                <div class="col-md-6 g-mb-60">
                    <h3 class="h4 text-slate-700 font-bold text-lg"><span class="g-font-size-25">01.</span> İyi
                        Programlar</h3>
                    <p class="text-xs">Bizim işimiz iyi programlar hazırlamak ve bu programları gerçekleştirmek.
                        Yıllardır
                        yolcularımızın en çok memnun olacağı programları hazırlıyoruz. Uçuş saatinden, tur
                        programına, ulaşım araçlarından, konaklayacağımız otellere kadar her şey en iyi şekilde
                        hazırlanıyor. </p>
                </div>
                <div class="col-md-6 g-mb-60"><img
                        src="https://image.inanctur.com.tr/yonetim/images/resimler/background/umre_resim_kabe_16.jpg?&amp;width=480"
                        alt="Image Description" class="img-fluid rounded-md"></div>
            </div>
            <div class="row">
                <div class="col-md-6 flex-md-unordered g-mb-60">
                    <h3 class="h4 text-slate-700 text-lg mt-3 font-bold"><span class="g-font-size-25">02.</span> Oteller
                    </h3>
                    <p class="text-xs"> En iyi otelleri tercih ediyoruz. Bu şekilde yoğun ibadet ve ziyaret programları
                        sonrası
                        rahat bir şekilde istirahat etmenize özen gösteriyoruz. Diğer bir ayırt edici
                        özelliğimiz en yakın otelleri seçiyoruz. Bu şekilde ibadetleriniz için gidip gelirken
                        zaman kaybına uğramıyorsunuz.
                        Türk damak tadına uygun açık büfe yemekler çıkaran otellerimizde huzurlu ve güvenli bir
                        şekilde faydalanabilirsiniz. Biz sadece ibadetlerinize odaklanmanız için her şeyi
                        düşünüyoruz. </p>
                </div>
                <div class="col-md-6 flex-md-first g-mb-60"><img
                        src="https://image.inanctur.com.tr/yonetim/images/resimler/background/umre_resim_kabe_15.jpg"
                        alt="Image Description" class="img-fluid"></div>
            </div>
            <div class="row">
                <div class="col-md-6 g-mb-60">
                    <h2 class="h4 text-slate-700 text-lg mt-3 font-bold"><span class="g-font-size-25">03.</span>
                        HavaYolları
                    </h2>
                    <p class="text-xs">En koforlu havayollarını tercih ediyoruz. Gün kaybına uğratmayan uçuş saatlerini organize
                        ederek, sizlere hizmetin en kalitesini veriyoruz. Söz verdiğimiz Havayolu ve Uçuş ile
                        sizlere konforlu bir seyahat vaadediyoruz. Ayrıca Türkiye'nin neresinden olursa olsun
                        eğer bulunduğunuz şehirden İstanbul Havalimanına THY uçuşu varsa, ücretsiz
                        aktarma uçuşunuz hediyemiz.</p>
                </div>
                <div class="col-md-6 g-mb-60"><img
                        src="https://image.inanctur.com.tr/yonetim/images/resimler/night-flight-2307018_1280.jpg?&amp;width=450"
                        alt="Image Description" class="img-fluid"></div>
            </div>
            <h2 class="text-slate-700 font-bold text-lg text-center g-mb-30">Özel Bir Rehberlik Anlayışı</h2>
            <p class="text-xs">Standartarı unutun ! Şimdi standartlar üstü bir rehberliğe hazırlanın. Tüm rehber ve
                hocalarımız
                Türkiye vatandaşı olmakla beraber, Mekke veya Medine'de ikamet etmektedir. </p>
    
            <p class="text-xs">On Binlerce yolcumuz yanılmış olamaz. %97 'yi aşan memnuniyet oranıyla önemli bir başarı
                yakalayan acentamız ile siz de özel bir umre hizmetine davetlisiniz. Burada iyi bir hizmet
                alırsınız. Umre otelinden, rehberine kadar tüm detaylarıyla hazırlanmış standartların üstünde
                bir umre organizasyonu sunuyoruz.
            </p>

            <h3 class="text-xl text-black my-3 font-medium">Her Şey Net !</h3>
            <p class="text-xs">Programlarımızda Her Şey Net . Otelinizin isminden, uçuş bilgilerinize, tur
                tarihlerinden,
                rehberinizin ismine kadar her şey siz daha rezervasyon yapmadan hazır. Sistemli çalışma altyapımız
                ile tüm programlar en küçük ayrıntısına kadar önceden hazırlanıyor. Sizler umre programınız boyunca
                en küçük aksaklık yaşanmayın diye gece gündüz daha iyi olmak için çalışıyoruz. </p>
            <div class="float-left g-max-width-300 g-ml-minus-100--lg mr-5">
                <blockquote class="g-color-black g-font-weight-600 g-font-style-italic g-font-size-20">
                    "Müşterilerinize verdiğiniz değerle her zaman en öndesiniz "</blockquote>
            </div>
            <p></p>
            <p class="text-xs">İnanç Turizm olarak sürdürülebilir bir başarının ancak yüksek müşteri memnuniyeti ve
                bağlılığı ile
                sağlanabileceğine inanırız. Bu nedenle İnanç Turizm'in hem müşteri hem de çalışanlarımızın ilk
                tercihi olmasını sağlamak üzere kendimizi sürekli geliştiririz.</p>
            <p class="text-xs font-semibold">İnanç Turizm çalışanları;</p>
            <ul class="list list-disc px-2 mx-2	">
                <li class="text-xs ml-1 pl-1 list-style-bullet">Bu kurumda müşteriler için ve müşteriler sayesinde var
                    olduğunu bilir.</li>
                <li class="text-xs ml-1 list-style-bullet">Müşterilerin, kendilerini değerli hissetmek istediğini bilir.
                </li>
                <li class="text-xs ml-1 list-style-bullet">Müşterileri tanımak, müşterilerin özelliklerini, ihtiyaç ve
                    beklentilerini anlamak için çaba
                    gösterir.</li>
                <li class="text-xs ml-1 list-style-bullet">Müşterileri her zaman dinlemeye hazırdır, sorunlarıyla
                    ilgilenir ve çözüm için gerekli desteği
                    verir.</li>
                <li class="text-xs ml-1 list-style-bullet">Müşterileri tam ve zamanında bilgilendirmeye önem verir.
                    Bilgilerin net ve anlaşılır olmasına
                    özen gösterir.</li>
                <li class="text-xs ml-1 list-style-bullet">Yönetim tarafından alınan kararları gerekçeleri ile birlikte
                    açıklar.</li>
                <li class="text-xs ml-1 list-style-bullet">Müşterilerine tutabileceği sözler verir, dürüst ve açık
                    iletişim kurar.</li>
                <li class="text-xs ml-1 list-style-bullet">"Müşteri bilgilerinin gizliliği” ilkesine sadık kalarak
                    hizmet verir.</li>
                <li class="text-xs ml-1 list-style-bullet">Müşterileri ile uzun vadeli, her iki taraf açısından da adil
                    ve kazandıran bir ilişki kurmayı
                    hedefler.</li>
                <li class="text-xs ml-1 list-style-bullet">Sadece hizmetlerin satışı sırasında değil, müşterinin
                    firmamız ile tüm ilişkisi süresince
                    kaliteli hizmet sunar.</li>
            </ul>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';

const sidebar = ref(false);
const {  addScript } = useCommon()


const show = (visibility) => {
    sidebar.value;
}
defineExpose({
    show
})

onMounted(()=>{ 
//     addScript("//www.instagram.com/embed.js`");
})
</script>